import { backendAPI } from '../global';

const getGlobalConfig = () => {
  return backendAPI.get('/globalConfig');
};

const updateGlobalConfig = (holidayMode) => {
  return backendAPI.post('/globalConfig', { holidayMode });
};

export default {
  getGlobalConfig,
  updateGlobalConfig,
};
